// angular
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

// others
import { AppService } from '../../app.service';
import { MeFooterComponent } from '../me-footer/me-footer.component';
import { ProfileService } from '../profile/profile.service';
import { AuthService } from '../../core/auth.service';

@Component({
    selector: 'me-footer-non-medical',
    templateUrl: './footer-non-medical.component.html',
    styleUrls: ['./footer-non-medical.component.scss'],
    providers: [ProfileService]
})

export class FooterNonMedicalComponent extends MeFooterComponent implements OnInit {
    data: any;
    languageLocale: string;
    language: any;
    languages = this.appService.meLanguages;
    country = this.appService.getMeClinicFolder() ?? 'core';
    countries = [
        {
            name: 'Germany',
            locale: 'core',
        },
        {
            name: 'Switzerland',
            locale: 'ch'
        }
    ];
    url = 'navigation/footer-non-medical';

    constructor(
        public appService: AppService,
        public profileService: ProfileService,
        public authService: AuthService,
        public translate: TranslateService,
        public router: Router
    ) {
        super(appService, profileService, authService, translate);
    }

    ngOnInit() {
        super.ngOnInit();

        this.appService.meClinicFolderChanged.subscribe(value => {
            if (value != '') {
                this.country = value;
                this.getContent();
            }
        });
    }

    changeContry() {
        this.router.navigate(['/me/login']);
    }
}
